// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  color: #495057;
  font-weight: 600;
}

.card {
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
}

.bg-light-success {
  background-color: #d1e7dd !important;
}

.bg-light-danger {
  background-color: #f8d7da !important;
}

.bg-light-primary {
  background-color: #cff4fc !important;
}

.table th {
  border-top: none;
  font-weight: 600;
  font-size: 0.875rem;
}

.table td {
  vertical-align: middle;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
}

.alert {
  border: none;
  border-radius: 0.5rem;
  font-weight: 500;
}

.alert i {
  margin-right: 0.5rem;
}

.fs-2x {
  font-size: 2rem !important;
}

.fs-3 {
  font-size: 1.5rem !important;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.875rem;
}

.import-errors-table {
  max-height: 22rem;
  overflow: auto;
}

.import-errors-table table {
  width: 100%;
  margin-bottom: 0;
  table-layout: auto;
}

/* Override global .table td truncation (styles.scss max-width: 320px + ellipsis) */
.import-errors-table .table th,
.import-errors-table .table td {
  max-width: none !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.import-error-row-number {
  white-space: nowrap !important;
  width: 1%;
  vertical-align: top;
}

.import-error-reason {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  min-width: 0;
  vertical-align: top;
  line-height: 1.5;
}

.import-error-reason .text-danger {
  display: block;
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.pagination-summary {
  font-size: 0.875rem;
}

.page-link {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/import-results-modal/import-results-modal.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mFAAmF;AACnF;;EAEE,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[".modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-title {\n  color: #495057;\n  font-weight: 600;\n}\n\n.card {\n  border: none;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  transition: transform 0.2s ease-in-out;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n}\n\n.bg-light-success {\n  background-color: #d1e7dd !important;\n}\n\n.bg-light-danger {\n  background-color: #f8d7da !important;\n}\n\n.bg-light-primary {\n  background-color: #cff4fc !important;\n}\n\n.table th {\n  border-top: none;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.table td {\n  vertical-align: middle;\n  font-size: 0.875rem;\n}\n\n.badge {\n  font-size: 0.75rem;\n  padding: 0.375rem 0.75rem;\n}\n\n.alert {\n  border: none;\n  border-radius: 0.5rem;\n  font-weight: 500;\n}\n\n.alert i {\n  margin-right: 0.5rem;\n}\n\n.fs-2x {\n  font-size: 2rem !important;\n}\n\n.fs-3 {\n  font-size: 1.5rem !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n  font-size: 0.875rem;\n}\n\n.import-errors-table {\n  max-height: 22rem;\n  overflow: auto;\n}\n\n.import-errors-table table {\n  width: 100%;\n  margin-bottom: 0;\n  table-layout: auto;\n}\n\n/* Override global .table td truncation (styles.scss max-width: 320px + ellipsis) */\n.import-errors-table .table th,\n.import-errors-table .table td {\n  max-width: none !important;\n  overflow: visible !important;\n  text-overflow: unset !important;\n}\n\n.import-error-row-number {\n  white-space: nowrap !important;\n  width: 1%;\n  vertical-align: top;\n}\n\n.import-error-reason {\n  white-space: normal !important;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  min-width: 0;\n  vertical-align: top;\n  line-height: 1.5;\n}\n\n.import-error-reason .text-danger {\n  display: block;\n  white-space: normal !important;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.pagination-summary {\n  font-size: 0.875rem;\n}\n\n.page-link {\n  cursor: pointer;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
